module.exports = __webpack_public_path__ + "myreplast-christmas.png?3fcb771d15351a76c1ee59373530690f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/myreplast-christmas.png
// module id = 236
// module chunks = 0